/**
 * Back in stock (docs/09 Klaviyo, docs/apps.md, docs/product.md "Back in
 * stock hook").
 *
 * buy-buttons.liquid renders, for every variant, the submit button and a
 * hidden type="button" trigger carrying Klaviyo's `klaviyo-bis-trigger` class.
 * For a sold out variant the submit button is disabled ("Email me when it's
 * back") and carries data-back-in-stock. Klaviyo's onsite JavaScript, loaded
 * only by its app embed, attaches its back in stock form to the trigger
 * class. This script shows the trigger and hides the disabled button when
 * that JavaScript is present and the variant is sold out, and keeps the two
 * in step as product-info.js rewrites the submit button on variant changes.
 * With the embed off nothing here changes: the disabled button stays and
 * the theme loads nothing from Klaviyo.
 */
(() => {
  if (document.querySelector('main[data-template]')?.dataset.template !== 'product') return;

  const klaviyoPresent = () => typeof window.klaviyo !== 'undefined' || typeof window._learnq !== 'undefined';

  const triggers = () =>
    Array.from(document.querySelectorAll('[data-back-in-stock-trigger]')).filter(
      (trigger) => !trigger.closest('quick-add-modal')
    );

  const sync = (trigger) => {
    const submit = trigger.closest('product-form')?.querySelector('.product-form__submit');
    if (!submit) return;
    const swap = klaviyoPresent() && submit.hasAttribute('data-back-in-stock');
    trigger.hidden = !swap;
    submit.hidden = swap;
  };

  const watch = (trigger) => {
    const submit = trigger.closest('product-form')?.querySelector('.product-form__submit');
    if (!submit) return;
    sync(trigger);
    new MutationObserver(() => sync(trigger)).observe(submit, {
      attributes: true,
      attributeFilter: ['data-back-in-stock', 'disabled'],
    });
  };

  // Klaviyo's script is async and may land after this one: poll for up to
  // five seconds, then leave the fallback in place.
  const waitForKlaviyo = (attempt = 0) => {
    if (klaviyoPresent()) {
      triggers().forEach(watch);
      return;
    }
    if (attempt < 10) window.setTimeout(() => waitForKlaviyo(attempt + 1), 500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => waitForKlaviyo(), { once: true });
  } else {
    waitForKlaviyo();
  }
})();
